import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import { IconBasket } from './Icons';
import {Loader} from 'react-loaders';
import ls from 'local-storage';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Basket extends Component {

  @observable showProcessing = false;
  @observable showResponse = false;
  @observable showEmptyViews = false;
  @observable responseText = '';

  @observable basket = {
    price : '',
    name : '',
    description : '',
  }

  @observable basketProduct = {};


  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;


    let scope = this;

    $(window).on('BASKET-data',(e,dataJson)=>{


      //console.log('dataJson',e,dataJson);
  //    this.basket.price = dataJson.price;
   //   this.basket.name = dataJson.name;
    //  this.basket.description = dataJson.description;

      this.basketProduct = dataJson;
    });

    this.externalFunctions();

  }

  componentDidMount = function(){
    function ClipartList() {

      this.data = [];

    }
  }

  onClickBuy(forced){



    var countViewsIDS = 0;
    this.showEmptyViews = false;
    bf_project.saveProject().then((data)=>{

      if ( !data || data.id == undefined ) return;

      if ( ! bf_project.haveViewsLayers() && !forced )
      {
       this.showEmptyViews = true;
        return;
      }

     this.showProcessing = true;

      var viewsIDS = bf_project.getViewsIDS();

      var images_array = [];
      var help_images_array = [];

      var bfLayersData = bf_project.getAllViews();

      for ( var i in bfLayersData )
      {
        var layer = bfLayersData[i].data.layers;



        for ( var x in layer )
        {

          if ( $.inArray(layer[x].path,help_images_array) == -1 )
          {
            if ( layer[x].path !== undefined ){


              var obj = {};
              obj.path = layer[x].path;
              obj.originalName = layer[x].originalName;
              images_array.push(obj);
              help_images_array.push(layer[x].path);

            }
          }

        }
      }

      var data_gen = { 'clientID' : bf_config.clientID, 'prodID' : bf_config.prodID, 'page_gen_url' : bf_config.generate_page_url, 'viewIDS':viewsIDS, 'images':images_array };

      if ( bf_config.designeID != null )
      {
        data_gen.konfiguratorid = bf_config.designeID;
      }


      $.ajax({
        url: bf_config.generate_url,
        method: 'GET',
        dataType: "jsonp",
        data : data_gen
      })
        .done(( data )=> {

          countViewsIDS--;
          if ( data.response == "success" )
          {
            $(window).trigger('processing-ready',data);

          }
          else
          {
            this.showResponse = true;
            this.responseText = 'Something has gone wrong. Please try again.';
            this.showProcessing = false;

          }
        }).fail(()=>{
        this.showResponse = true;
        this.responseText = 'Something has gone wrong. Please try again.';
        this.showProcessing = false;

      });

    })
  }
//EKUSD
  calculateCurrency(product){

    if ( product.dealerGroupId && ["EKUSD","HUSD","USA"].includes(product.dealerGroupId) ||  !product.dealerGroupId && ( bf_config.shopLang === 'en' || bf_config.shopLang === 'us') )
    {
      return '$';
    }
    return '&euro;';
  }

  render() {

    const trans = this.trans;
    const t = this.t;
    const langCode =  this.props.dictionaryStorage.currentLang;
    const product = toJS(this.basketProduct);

    const name =  this.tp(product,langCode,'name');
    const description =  this.tp(product,langCode,'description');

    const dealerGroupId = product.dealerGroupId;
    const currency = this.calculateCurrency(product);
    const price = product.price;
    //const { name, description, price } = this.basket;
    const { basket } = this.props.config;

    return (
      <div className={"Basket "+ (this.props.mobiVersion ? 'BasketMobi' : '') }>
        {
          ( this.showProcessing  )
          &&
          <div className="Basket-processing">
            <div className="spinner">
              <div className="rect1"></div>
              <div className="rect2"></div>
              <div className="rect3"></div>
              <div className="rect4"></div>
              <div className="rect5"></div>
            </div>
          </div>
        }
        {
          ( this.showResponse )
          &&
          <div className="Basket-message" onClick={ ()=> { this.showResponse = false }}>
            <span className="Basket-message-close"><span>+</span></span>
            <p>{t( this.responseText)}</p>
          </div>
        }
        {
          ( this.showEmptyViews )
          &&
          <div className="Basket-message Basket-message-empty" onClick="">
            <p>
              { t('Probably You have some empty views. Are you sure to continue order?') }
              <span>
                <button onClick={ ()=> { this.showEmptyViews = false } }>{t('Cancel') }</button>
                <button onClick={ ()=> { this.onClickBuy(true) } } >{t('Continue') }</button>
              </span>
            </p>
          </div>
        }
        <div className={"Basket-button " + (this.showEmptyViews || this.showResponse || this.showProcessing ? 'Basket-button-action' : '') } onClick={()=> { this.onClickBuy() } }>
          <p className="Basket-text">{  basket.update ?  t('Update') :  t('Add to Basket')}</p>
          {
            !this.props.mobiVersion
              &&
            <IconBasket />
          }
          <div className="Basket-block">
            <h6 className={"Basket-description " + ( (name && name.length > 12) ? 'Basket-description-long' : '' ) }>{name} { false && <i>i<span>{description}<span></span></span></i> }</h6>
            <p className="Basket-price ab">{price} <span dangerouslySetInnerHTML={ { __html : currency }} ></span><span>*</span></p>
          </div>
        </div>

        { false && <p className="info"><span>&nbsp;</span><span>{t('Delivery within 2 working days')}</span></p> }
        { false &&
        <button className={"btn_buy js-btn-buy" + (this.showProcessing ? ' processing' : '')} data-forced="false">
          {
            basket.update
              ?
              <span>{ t('Update') }<i className="fa fa-angle-right" aria-hidden="true"></i></span>
              :
              <span>{ t('Add to Basket') } <i className="fa fa-angle-right" aria-hidden="true"></i></span>
          }


          <span>{t('Processing') } <span className="small-loader"><span></span></span></span>
        </button>
        }
        {
          false &&

        <div className="js-forced-buy forced-buy hide">
          <p> { t('Probably You have some empty views. Are you sure to continue order?') }</p>
          <button className={"btn_buy js-btn-buy-forced" + (this.showProcessing ? ' processing' : '')} data-forced="true">

            <span>{t('Continue') } <i className="fa fa-angle-right" aria-hidden="true"></i></span>

            <span>{t('Processing') } <span className="small-loader"><span></span></span></span>
          </button>
          <div className="forced-buy-or">
            {t('OR') }
          </div>
          <button className={"btn_buy js-btn-buy-cancel" + (this.showProcessing ? ' processing' : '')} data-forced="true">

            <span>{t('Cancel') } <i className="fa fa-angle-right" aria-hidden="true"></i></span>

            <span>{t('Processing') } <span className="small-loader"><span></span></span></span>
          </button>
        </div>
        }

      </div>
    );


  }

  externalFunctions(){
    var countViewsIDS = 0;

    let scope = this;

    $(document).on('click',".js-btn-buy-cancel",function () {
      $('.js-forced-buy').addClass('hide');
    });



    $(document).on('click',".js-btn-buy, .js-btn-buy-forced",function () {

      if ( $(this).hasClass('processing') ) return;

      var th = $(this);

      bf_project.saveProject().then(function(data){


        if ( !data || data.id == undefined ) return;

        if ( ! bf_project.haveViewsLayers() && th.hasClass('js-btn-buy') )
        {
          $('.js-forced-buy').removeClass('hide');
          return;
        }

        th.addClass('processing');

        var viewsIDS = bf_project.getViewsIDS();




        var images_array = [];
        var help_images_array = [];

        var bfLayersData = bf_project.getAllViews();

        for ( var i in bfLayersData )
        {
          var layer = bfLayersData[i].data.layers;



            for ( var x in layer )
            {

              if ( $.inArray(layer[x].path,help_images_array) == -1 )
              {
                if ( layer[x].path !== undefined ){


                  var obj = {};
                  obj.path = layer[x].path;
                  obj.originalName = layer[x].originalName;
                  images_array.push(obj);
                  help_images_array.push(layer[x].path);

                }
              }

          }
        }

        var data_gen = { 'clientID' : bf_config.clientID, 'prodID' : bf_config.prodID, 'page_gen_url' : bf_config.generate_page_url, 'viewIDS':viewsIDS, 'images':images_array };

        if ( bf_config.designeID != null )
        {
          data_gen.konfiguratorid = bf_config.designeID;
        }
        // console.log('data_gedn2: ',data_gen); return;
        //konfiguratorid



        $.ajax({
          url: bf_config.generate_url,
          method: 'GET',
          dataType: "jsonp",
          data : data_gen
        })
          .done(function( data ) {

            countViewsIDS--;
            if ( data.response == "success" )
            {
              $(window).trigger('processing-ready',data);
            }
            else
            {
              scope.showResponse = true;
              scope.responseText = 'Something has gone wrong. Please try again.';

              $('.js-btn-buy').removeClass('processing');
             // htmlSuccess = 'Something has gone wrong. Please try again.';
             // $('.fake-response').html(htmlSuccess);
             // $('.fake-response').fadeIn(500);
            }
          }).fail(function(){
          scope.showResponse = true;
          scope.responseText = 'Something has gone wrong. Please try again.';
          $('.js-btn-buy').removeClass('processing');
          //htmlSuccess = 'Something has gone wrong. Please try again.';
          //$('.fake-response').html(htmlSuccess);
          //$('.fake-response').fadeIn(500);
        });

      })

    });

    var htmlSuccess = '';


    $(window).on('processing-ready',function(e,data){


      let obj ={
        clientID :bf_config.clientID,
        konfiguratorid : bf_config.designeID,
      }
        // do we still need it?
        if (bf_config.generate_confirm_url) {

            $.ajax({
                cache: false,
                data: obj,
                dataType: "jsonp",
                method: "GET",
                url: bf_config.generate_confirm_url,
                success: function (data) {

                }
            });
        }

       /*
       {
       "name":"ProdcutName"
       "designId": -which is the "id" of the current project that user is working on. Which then should be used when User would like to rearrange his project from your basket.
       "print" - "printFile" - do U need it here - because U will have it in a zip file ( Mark wanted to have all files that were used for project)
       "tn" : "miniature"
       "zip":  pathToZipFile.zip - that contains: fileToPrint, FileToPreview, and project images that were added to project
       "session" : "sessionId"
       }
       */

      
      var dataCard = new Object();
      dataCard.name = bf_project.getName();
      dataCard.price = bf_project.getPrice();
      dataCard.prices = bf_project.getPricesFlorianStrcuture();
      dataCard.konfiguratorid = bf_config.designeID;
      //dataCard.designId = bf_config.designeID;
      dataCard.print = data.print;
      dataCard.tn = data.thumbnail;
      dataCard.zip = data.zip;
      dataCard.session = bf_config.clientID;

      if (  bf_config.hasOwnProperty('external')) {
        dataCard.external = bf_config.external;
      }

      dataCard.productID =  bf_config.prodID;


      if ( bf_config.dev ==  true )
      {
        scope.showProcessing = false;
        console.log('DEV VERSION: Success with generating print: ', data.zip);
        return;
      }


      let langUrl = '';
      let lang =  bf_config.shopLang;
      if ( lang != undefined && lang != '' && lang != 'de' )
      {
        langUrl = '/'+lang;
      }

      let addToCardWithLang = bf_config.shopUrl + langUrl + bf_config.shopUrlApi +  bf_config.shopUrlApiAddToCard;
      //console.log('addToCardWithLang',addToCardWithLang);

      $.ajax({
        cache: false,
        data : JSON.stringify(dataCard),
        dataType: "json",
        method : "post",
        xhrFields: {
          withCredentials: true
        },
        url:  addToCardWithLang,
        success: function(data)
        {

          if ( data.success == true )
          {
            $.ajax({
              // cache: false,
              headers: {
                'x-client-id': bf_config.clientID
              },
              dataType: "json",
              method : "post",
              url:  bf_config.api + 'design/'+ bf_config.designeID +'/in-cart',
              success: function(data)
              {

              }
            });

            if ( data.hasOwnProperty('carturl') ) {
              //window.parent.postMessage({"ilshowcart_redirect" : true, "url": data.carturl}, "*");
              window.location = data.carturl;
            } else {
              window.parent.postMessage("ilshowcart", "*");
            }


            //window.parent.postMessage('addtocard','*');

            scope.showResponse = true;
            scope.responseText = 'Your product was added to basket.';

            $('.js-btn-buy').removeClass('processing');

          }
          else {
            scope.showProcessing = false;
            scope.showResponse = true;
            scope.responseText = 'Something has gone wrong. Please try again.';;



          }
          $('.js-btn-buy').removeClass('processing');

        },
        error:function()
        {

          scope.showProcessing = false;
          scope.showResponse = true;
          scope.responseText = 'Something has gone wrong. Please try again.';;
        }

      });


    })

    $(document).ready(function(){
      if ( $('#bf-basket').length > 0 ) {
        session.getSessionFromShop().then(function () {
          //   bfCreateBuy();
        });
      }
    });

  }

}






